import '../assets/NcAppNavigationCaption-jV1y8HQ1.css';
import { N as a } from "./NcActions-B1Ue3gj8.mjs";
import { n as i } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const s = {
  name: "NcAppNavigationCaption",
  components: {
    NcActions: a
  },
  inheritAttrs: !1,
  props: {
    name: {
      type: String,
      required: !0
    },
    /**
     * Enable when used as a heading
     * e.g. Before NcAppNavigationList
     */
    isHeading: {
      type: Boolean,
      default: !1
    },
    /**
     * Any [NcActions](#/Components/NcActions?id=ncactions-1) prop
     */
    // Not an actual prop but needed to show in vue-styleguidist docs
    // eslint-disable-next-line
    " ": {}
  },
  computed: {
    wrapperTag() {
      return this.isHeading ? "div" : "li";
    },
    captionTag() {
      return this.isHeading ? "h2" : "span";
    },
    // Check if the actions slot is populated
    hasActions() {
      return !!this.$slots.actions;
    }
  }
};
var o = function() {
  var n = this, t = n._self._c;
  return t(n.wrapperTag, { tag: "component", staticClass: "app-navigation-caption", class: { "app-navigation-caption--heading": n.isHeading } }, [t(n.captionTag, { tag: "component", staticClass: "app-navigation-caption__name" }, [n._v(" " + n._s(n.name) + " ")]), n.hasActions ? t("div", { staticClass: "app-navigation-caption__actions" }, [t("NcActions", n._g(n._b({ scopedSlots: n._u([{ key: "icon", fn: function() {
    return [n._t("actionsTriggerIcon")];
  }, proxy: !0 }], null, !0) }, "NcActions", n.$attrs, !1), n.$listeners), [n._t("actions")], 2)], 1) : n._e()], 1);
}, e = [], r = /* @__PURE__ */ i(
  s,
  o,
  e,
  !1,
  null,
  "213c8156",
  null,
  null
);
const l = r.exports;
export {
  l as N
};
